<template>
  <div>
    <el-descriptions title="基本信息" border>
      <el-descriptions-item label="名称">{{ kangjiaInfo.title }}</el-descriptions-item>
      <el-descriptions-item label="简介">{{ kangjiaInfo.introduce }}</el-descriptions-item>
      <el-descriptions-item label="地址">{{ kangjiaInfo.address }}</el-descriptions-item>
      <el-descriptions-item label="营业时间">{{ kangjiaInfo.office_hours }}</el-descriptions-item>
      <el-descriptions-item label="二维码">
        <el-image style="width: 60px;" :src="kangjiaInfo.qr_code" :preview-src-list="[kangjiaInfo.qr_code]">
        </el-image>
      </el-descriptions-item>
      <el-descriptions-item label="资质">
        <el-image style="width: 60px;" :src="kangjiaInfo.certificate" :preview-src-list="[kangjiaInfo.certificate]">
        </el-image>
      </el-descriptions-item>
    </el-descriptions>

    <!--    <el-button @click="handleEdit" type="primary" size="small" icon="el-icon-edit"
      style="margin-top: 10px;">编辑</el-button> -->
    <!--    <el-dialog title="编辑基本信息" :visible.sync="dialogVisible" width="1000px" :before-close="closeDialog" top="5vh">
      <el-form ref="form" :model="form" label-width="80px" size="small">
        <el-row>
          <el-col :span="8">
            <el-form-item label="名称" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性质" prop="nature">
              <el-select v-model="form.nature" placeholder="请选择">
                <el-option :value="1" label="公立医院"></el-option>
                <el-option :value="2" label="民营医院"></el-option>
                <el-option :value="3" label="综合门诊"></el-option>
                <el-option :value="4" label="社康"></el-option>
                <el-option :value="5" label="药店"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="康家等级" prop="grade">
              <el-select v-model="form.grade" placeholder="请选择">
                <el-option :value="1" label="一级丙等"></el-option>
                <el-option :value="2" label="一级乙等"></el-option>
                <el-option :value="3" label="一级甲等"></el-option>
                <el-option :value="4" label="二级丙等"></el-option>
                <el-option :value="5" label="二级乙等"></el-option>
                <el-option :value="6" label="二级甲等"></el-option>
                <el-option :value="7" label="三级丙等"></el-option>
                <el-option :value="8" label="三级乙等"></el-option>
                <el-option :value="9" label="三级甲等"></el-option>
                <el-option :value="10" label="三级特等"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人" prop="contacts">
              <el-input v-model="form.contacts"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式" prop="contactInformation">
              <el-input v-model="form.contactInformation"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="前台电话" prop="frontDeskNumber">
              <el-input v-model="form.frontDeskNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="form.email" type="email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="营业时间" prop="businessTime">
              <el-time-picker is-range v-model="form.businessTime" range-separator="—" value-format="HH:mm">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="详细地址" prop="address">
              <el-input v-model="form.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="营业日" progress="businessDay">
              <el-checkbox-group v-model="form.businessDay">
                <el-checkbox label="星期一"></el-checkbox>
                <el-checkbox label="星期二"></el-checkbox>
                <el-checkbox label="星期三"></el-checkbox>
                <el-checkbox label="星期四"></el-checkbox>
                <el-checkbox label="星期五"></el-checkbox>
                <el-checkbox label="星期六"></el-checkbox>
                <el-checkbox label="星期日"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="特色项目">
              <div class="flex">
                <el-input v-model="specialProjectVal" @keyup.enter.native="handleSpecialProjectAdd"
                  placeholder="请输入特色项目" style="width: 220px;margin-right: 10px;"></el-input>
                <el-button @click="handleSpecialProjectAdd" size="mini" type="primary"
                  icon="el-icon-plus">添加</el-button>
              </div>
              <div style="margin-top: 10px;">
                <el-tag type="info" effect="plain" closable :key="tag" v-for="tag in form.project"
                  @close="handleTagDel(tag)">{{ tag }}</el-tag>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="康家简介" prop="introduction">
              <el-input v-model="form.introduction" type="textarea"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医院公告" prop="notice">
              <el-input v-model="form.notice" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button @click="handleSubmit" type="primary">提交</el-button>
      </span>
    </el-dialog> -->
    <!--    <el-form label-width="100px" label-position="left" class="margin-t-20" style="width: 500px;">
      <el-form-item label="康家二维码">
        <el-upload :auto-upload="false" :on-success="QRcodeSuccess" :action="uploadUrl" list-type="picture-card"
          :limit="1">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="门店照片">
        <el-upload :action="uploadUrl" list-type="picture-card" :limit="1" :on-success="masterMapSuccess">
          <i class="el-icon-plus"></i>
          <div slot="tip">主图</div>
        </el-upload>
        <el-upload :action="uploadUrl" list-type="picture-card" multiple :limit="5" :on-success="contextSuccess"
          :on-remove="contextRemove" :file-list="contextDiagramList">
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">环境图</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="Banner">
        <el-upload :action="uploadUrl" list-type="picture-card" multiple :limit="5" :on-success="bannerSuccess"
          :on-remove="bannerRemove" :file-list="bannerList">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleSubmit" type="primary">保存</el-button>
      </el-form-item>
    </el-form> -->
  </div>
</template>

<script>
  export default {
    name: 'BaseInfo',
    data() {
      return {
        uploadUrl: this.$util.host + '/upload',
        kangjiaInfo: {},

        dialogVisible: false,
        form: {
          name: '',
          nature: '',
          grade: '',
          contacts: '',
          contactInformation: '',
          email: '',
          businessDay: [],
          businessTime: '',
          address: '',
          project: [],
          QRcode: '',
          introduction: '',
          notice: '',
          masterMap: '',
          contextDiagram: '',
          banner: ''
        },
        // 特殊项目val
        specialProjectVal: '',
        // 二维码列表
        qrFileList: [],
        // 主图列表
        mainPictureFileList: [],
        // 环境图列表
        envPictureFileList: [],
        // 广告图列表
        bannerFileList: [],

        name: '',
        nature: '',
        grade: '',
        contacts: '',
        contactInformation: '',
        email: '',
        businessDay: [],
        businessTime: '',
        address: '',
        project: [],
        inputValue: '',
        inputVisible: '',
        introduction: '',
        info: [],
        infoList: {},
        contextDiagramList: [],
        contextDiagramList1: [],
        bannerList: [],
        bannerList1: [],
      }
    },
    mounted() {
      this.getKangjiaInfo()
    },
    methods: {
      handleEdit() {
        this.dialogVisible = true
      },
      closeDialog() {
        this.dialogVisible = false
      },
      handleSpecialProjectAdd() {
        if (!this.specialProjectVal) return

        let isExisting = this.form.project.indexOf(this.specialProjectVal) !== -1

        if (isExisting) {
          this.$message.info('已存在')
          return
        }
        this.form.project.push(this.specialProjectVal)
        this.specialProjectVal = ''
      },
      handleTagDel(tag) {
        let index = this.form.project.indexOf(tag)
        this.form.project.splice(index, 1);
      },
      // 保存按钮
      handleSubmit() {
        console.log('form', this.form);
        // this.$util.post('merchant/setInfo', {
        // 	info: this.info
        // }).then(res => {
        // 	if (res.code == 0) {
        // 		this.$message('已保存')
        // 		this.getKangjiaInfo()
        // 	} else {
        // 		this.$message(res.msg)
        // 	}
        // })
      },

      getKangjiaInfo() {
        this.$util.get('merchant/info').then(res => {
          this.kangjiaInfo = res

          // this.contextDiagramList = []
          // this.bannerList = []
          // if (res.info && res.info.length > 0) {
          //   this.info = res.info
          //   this.infoList = this.info[0]
          //   this.businessDay = this.infoList.businessDay
          //   this.project = this.infoList.project
          //   if (this.infoList.contextDiagram && this.infoList.contextDiagram.length > 0) {
          //     this.infoList.contextDiagram.forEach(item => {
          //       this.contextDiagramList.push({
          //         url: item
          //       })
          //       this.contextDiagramList1.push({
          //         url: item
          //       })
          //     });
          //   }
          //   if (this.infoList.banner && this.infoList.banner.length > 0) {
          //     this.infoList.banner.forEach(banner => {
          //       this.bannerList.push({
          //         url: banner
          //       })
          //       this.bannerList1.push({
          //         url: banner
          //       })
          //     });
          //   }
          // } else {
          //   this.info = []
          //   this.businessDay = []
          //   this.project = []
          //   this.contextDiagramList = []
          //   this.bannerList = []
          // }
        })
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.project.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
      QRcodeSuccess(res) {
        this.infoList.QRcode = res.data
      },
      masterMapSuccess(res) {
        this.infoList.masterMap = res.data
      },
      contextSuccess(res) {
        this.contextDiagramList1.push({
          url: res.data
        })
      },
      contextRemove(file, fileList) {
        this.infoList.contextDiagram = []
        fileList.forEach(item => {
          this.contextDiagramList1.push({
            url: item.data
          })
        })
      },
      bannerSuccess(res) {
        this.bannerList1.push({
          url: res.data
        })
      },
      bannerRemove(file, fileList) {
        this.infoList.banner = []
        fileList.forEach(item => {
          this.bannerList1.push({
            url: item.data
          })
        })
      }
    }
  }
</script>

<style scoped>
</style>